import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthToken } from '../interfaces/autenticacion.interface';

const URL = environment.urlCognito;
const CLIENT = environment.clientCognito;
const SECRET = environment.secretCognito;
const ENDPOINT = "oauth2/token";

@Injectable({
  providedIn: 'root'
})
export class CognitoService {

  constructor(private http: HttpClient) { }

  public getToken(): Observable<AuthToken> {
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const body = 'client_id={0}&client_secret={1}&grant_type=client_credentials&scope={2}'
      .replace('{0}', CLIENT)
      .replace('{1}', SECRET)
      .replace('{2}', '');
    
    return this.http.post<AuthToken>(URL + ENDPOINT, body, httpOptions);
  }
}
